// ABOUTME: Brand logo lockup — the Daubly icon and wordmark side by side.
// ABOUTME: Uses the brand bingo card SVG icon with the Poppins ExtraBold wordmark.
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export function DaublyLogo() {
  return (
    <Box component="span" display="flex" alignItems="center" gap="14px">
      <svg width="36" height="36" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="1" y="1" width="50" height="50" rx="9" fill="#F97316"/>
        <rect x="4"  y="4"  width="13" height="13" rx="3" fill="white" opacity="0.35"/>
        <rect x="19" y="4"  width="13" height="13" rx="3" fill="white"/>
        <rect x="34" y="4"  width="13" height="13" rx="3" fill="white" opacity="0.35"/>
        <rect x="4"  y="19" width="13" height="13" rx="3" fill="white"/>
        <rect x="19" y="19" width="13" height="13" rx="3" fill="#14B8A6"/>
        <rect x="34" y="19" width="13" height="13" rx="3" fill="white" opacity="0.35"/>
        <rect x="4"  y="34" width="13" height="13" rx="3" fill="white" opacity="0.35"/>
        <rect x="19" y="34" width="13" height="13" rx="3" fill="white"/>
        <rect x="34" y="34" width="13" height="13" rx="3" fill="#14B8A6"/>
        <circle cx="25.5" cy="25.5" r="4.5" fill="white" opacity="0.8"/>
        <circle cx="40.5" cy="40.5" r="4.5" fill="white" opacity="0.8"/>
      </svg>
      <Typography variant="h6" component="span" fontWeight={800}>
        Daubly
      </Typography>
    </Box>
  )
}
